<script>
    export let selected = "51";

    let paises = [
        { label: "51", code: "pe", value: "51" },
        { label: "52", code: "mx", value: "52" },
        { label: "1", code: "us", value: "1" },
    ];

    $: seleccionado = paises.find((p) => p.value === selected) || paises[0];

    function seleccionarPais(pais) {
        selected = pais.value;
    }
</script>

<div class="dropdown">
    <button class="btn btn-outline-secondary dropdown-toggle d-flex align-items-center gap-1" type="button" data-bs-toggle="dropdown" aria-expanded="false">
        <img src={`https://flagcdn.com/h20/${seleccionado.code}.png`} alt="" />
        {seleccionado.label}
    </button>
    <ul class="dropdown-menu">
        {#each paises as pais}
            <li>
                <a class="dropdown-item d-flex align-items-center gap-1" href="#" on:click|preventDefault={() => seleccionarPais(pais)}>
                    <img src={`https://flagcdn.com/h20/${pais.code}.png`} alt="" />
                    {pais.label}
                </a>
            </li>
        {/each}
    </ul>
</div>
